module.exports = __webpack_public_path__ + "img/cask-placeholder.4849999.svg";